import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { SerialCreditApplicationRequest, SerialCreditApplicationResponse } from '../models/models'

export class ApplySerialCreditApi extends ClientProxy {
  constructor(props: any = {}) {
    super({
      url: 'compay-payment/apply-serial-credit',
      ...props,
    })
  }

  public async applyCredit(request: SerialCreditApplicationRequest): Promise<SerialCreditApplicationResponse> {
    return await this.postAsync<SerialCreditApplicationResponse>(request)
  }
}
